import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ComingSoon.css';

function ComingSoon() {
  const navigate = useNavigate();

  return (
    <div className="coming-soon">
      <div className="coming-soon-content">
        <div className="coming-soon-icon">🚀</div>
        <h1 className="coming-soon-title">Coming Soon</h1>
        <p className="coming-soon-text">
          This demo is currently being built. Check back soon for the full interactive experience!
        </p>
        <button className="back-btn" onClick={() => navigate('/')}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          Back to Home
        </button>
      </div>
    </div>
  );
}

export default ComingSoon;
